import { render, staticRenderFns } from "./MessageTextEditor.vue?vue&type=template&id=2257cbe1&scoped=true"
import script from "./MessageTextEditor.vue?vue&type=script&lang=ts"
export * from "./MessageTextEditor.vue?vue&type=script&lang=ts"
import style0 from "./MessageTextEditor.vue?vue&type=style&index=0&id=2257cbe1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2257cbe1",
  null
  
)

export default component.exports